module.exports = __webpack_public_path__ + "static/rashida-d8d471987c70fca267e77e1354141847.jpg";